/** Resposta paginada padrão das listagens do backoffice. */
export interface Paginado<T> {
  itens: T[];
  total: number;
  pagina: number;
  tamanhoPagina: number;
}

/** Argumentos das queries paginadas (por loja). */
export interface ListarPaginadoArgs {
  idConfig: number;
  /** 1-based. */
  pagina: number;
  tamanhoPagina: number;
}

/** Monta a query string de paginação a partir dos argumentos. */
export function qsPaginacao({ idConfig, pagina, tamanhoPagina }: ListarPaginadoArgs): string {
  return `idConfiguracaoCardapio=${idConfig}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`;
}
